module.exports = __webpack_public_path__ + "img/cwm-websitetiles-itcwt-f01-museum-72dpi.3cae5457.jpg";